// https://material.angular.io/components/table/overview
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FacturaRegimenFiscal } from '../../models/facturaRegimenFiscal';
import { FacturaFormaPago } from '../../models/FacturaFormaPago';
import { FacturaMetodoPago } from '../../models/FacturaMetodoPago';
import { FacturaUsoCFDI } from '../../models/FacturaUsoCFDI';
import { FacturaUnidadMedida } from '../../models/facturaUnidadMedida';
import { Item } from '../../models/item';
import { Organizacion } from '../../models/organizacion';
import { privateEncrypt } from 'crypto';
import { FacturaItem } from '../../models/facturaItem';
import { FacturaItemSAT } from '../../models/facturaItemSAT';
// import { NotaCargoModel, NotaCargoDocumento, NotaCargoDetail} from '../../models/nota-cargo';
import { NotaCargoModel, NotaCargoDocumento, NotaCargoDetail } from '../../models/nota-cargo';
import { Usuario } from '../../models/usuario';
import { forEach } from 'core-js/fn/array';
import { MatSelect } from '@angular/material/select';
/**
 * @title Table with pagination
 */

@Component({
  selector: 'app-nota-cargo-detalle',
  templateUrl: './nota-cargo-detalle.component.html',
  styleUrls: ['./nota-cargo-detalle.component.scss'],
  providers: [generalService]
})
export class NotaCargoDetalleComponent {

  public viewDataProd: any[];
    public viewDataProdEdit: any[];
    private itemsShowProd = 10;
    private filteredItemsShowProd = 10;
    private arrayFilteredProd = undefined;
    private isFilteredProd = false;
    private listaProductoEdit: any[];
    @ViewChild('infiniteSelect') selectElem: MatSelect;

    public viewDataSat: any[];
    public viewDataSatEdit: any[];
    private itemsShowSat = 10;
    private filteredItemsShowSat = 10;
    private arrayFilteredSat = undefined;
    private isFilteredSat = false;
    private listaSATCodeEdit: any[];
    @ViewChild('infiniteSelectSat') selectElemSat: MatSelect;

    notaCargo: NotaCargoModel = new NotaCargoModel();
    facturaTipo: number = null;
    idDocuments: string = null;
    price: number = null;
    totalFaltante: number = null;
    ventaDetalleListado: any[] = [];
    notaCargoAgregar: FormGroup;

    siguiente: boolean = false;
    titulo = 'Agregar';
    id: number = null; // id nota cargo

    listaSucursal: Organizacion[] = [];
    listaRegimenFiscal: FacturaRegimenFiscal[] = [];
    listaFormaPago: FacturaFormaPago[] = [];
    listaMetodoPago: FacturaMetodoPago[] = [];
    listaCFDI: FacturaUsoCFDI[] = [];
    listaSATCode: any[] = [];
    listaCargo: any[] = [];
    listaTipoRelacion: any[] = [];
    listaDocumento: any[] = [];

    listaProducto: FacturaItem[] = [];
    
    listaUnidad: FacturaUnidadMedida[] = [];

    subtotal: number = 0;
    impuestos: number = 0;
    total: number = 0;

    public seEstaEditando = false;
    public seEstaAgregando = false;
    public transaccionEnCurso = false;
    listaNotaCargoDetalle: NotaCargoDetail[] = [];
    listaNotaCargoDetalleAgregar: NotaCargoDetail[] = [];

    public dataSource = new MatTableDataSource<NotaCargoDetail>();
    public displayedColumns: string[] = [
      'acciones',
      'producto',
      'unidad',
      'satID',
      'descripcion',
      'cantidad',
      'valor',
      'aplicaIVA',
      'importeIVA',
      'total'
    ];
    public notaCargoDetalle: NotaCargoDetail =  new NotaCargoDetail();
    public unidadControl = new FormControl(null, [Validators.required]);
    public productoControl = new FormControl(null);
    public productoSATControl = new FormControl(null, [Validators.required]);
    public descripcionControl = new FormControl(null, [Validators.required, Validators.maxLength(250)]);
    public cantidadControl = new FormControl(null, [Validators.required, Validators.min(0), Validators.max(this.notaCargoDetalle.totalFaltante)]);
    public valorControl = new FormControl(null, [Validators.required, Validators.min(0)]);
    public importeIVAControl = new FormControl(null);
    public totalControl = new FormControl(null, [Validators.required, Validators.min(0)]);
    public aplicaIVAControl = new FormControl(true, [Validators.required]);

    public commentsControl = new FormControl(null);
    public idCliente = null;
    private formularioValido = true;

    private IVA_FIJO: number = .16;

    constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService, private route: ActivatedRoute) {
      this.dataService.guardado = false;
  }

  ngOnInit() {
    this.idCliente = this.dataService.factura.idCliente;
    this.importeIVAControl.disable();
    this.buildForm();
    this.consultarCFDI();
    this.consultarFormaPago();
    this.consultarMetodoPago();
    this.consultarRegimenFiscales();
    this.consultSATcode();
    this.consultarUnidades();
    this.consultarTipoRelacion();
    this.consultarDocumentos();
    this.consultarSucursales();
    if (this.dataService.tipo === 'editar') {
        this.titulo = 'Editar';
        this.id = this.dataService.id;
        this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
        this.getNotaCargo(this.dataService.id);
        this.getNotaCargoDetalle(this.dataService.id);
    } else {
        this.idDocuments = this.dataService.factura.idDocuments;
        this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
        this.notaCargoAgregar.controls['nombre'].setValue(this.dataService.factura.CUSTOMER_NAME);
        this.notaCargoAgregar.controls['cfdi'].setValue(2); // Devoluciones, descuentos o bonificación
        this.notaCargoAgregar.controls['rfc'].setValue(this.dataService.factura.CUSTOMER_RFC);
        this.notaCargoAgregar.controls['regimenFiscal'].setValue(this.dataService.factura.BILL_TAX_REGIME_ID);
        this.notaCargo = new NotaCargoModel();
        this.notaCargo.CUSTOMER_RFC = this.dataService.factura.CUSTOMER_RFC;
        this.notaCargo.CUSTOMER_NAME = this.dataService.factura.CUSTOMER_NAME;
        this.notaCargo.BILL_STATUS_ID = 1;
        if (this.facturaTipo === 1 && this.idDocuments !== null && this.idDocuments !== undefined) {
            this.getVentasDetalle();
        }
    }

}

getVentasDetalle() {
    this._generalService.metodoCallParams(this.idDocuments, `notaCargo/consultDocumentsByBill/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            console.log(res);
            this.ventaDetalleListado = res;
            if (this.id !== null) {  // Esta En modo Edicion
                this.ventaDetalleListado.forEach((element) => {
                    const encontrado = this.listaNotaCargoDetalle.findIndex((obj) => obj.CHARGE_NOTE_DETAIL_ID === element.CREDIT_NOTE_DETAIL_ID);
                    if (encontrado !== -1) {
                        this.listaNotaCargoDetalle[encontrado].isChecked = true;
                        // Si tiene iva factor checkear Tiene Iva
                        if (this.listaNotaCargoDetalle[encontrado].IVA_FACTOR !== null && this.listaNotaCargoDetalle[encontrado].IVA_FACTOR !== undefined) {
                            this.listaNotaCargoDetalle[encontrado].checkedIva = true;
                        } else {
                            this.listaNotaCargoDetalle[encontrado].checkedIva = false;
                        }
                        // Proceso para descontar la cantidades y el monto
                    } else {
                        const id = this.listaNotaCargoDetalleAgregar.length;
                        const unidad = this.listaUnidad.find((p) => p.BILL_UNIT_MEASURE_ID === element.BILL_UNIT_MEASURE_ID);
                        this.listaNotaCargoDetalle.push({
                            CHARGE_NOTE_DETAIL_ID: null,
                            CHARGE_NOTE_ID: null,
                            ITEM_SAT_ID: element.ITEM_SAT_ID,
                            ITEM_ID: element.ITEM_ID,
                            UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                            AMOUNT: element.TOTAL, // Sin iba 16% // Sin iba 16%
                            QUANTITY: element.QUANTITY,
                            DESCRIPTION:  element.NAME,
                            IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                            IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                            isChecked: true,
                            checkedIva: true,
                            total: element.TOTAL, // total con IVA
                            totalFaltante: 0,
                            price: (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                            index: id,
                            NAME: element.NAME, // Producto
                            NAME_SAT: element.NAME_SAT, // sat
                            unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                            AMOUNT_ORIGINAL: element.TOTAL
                        });
                        this.listaNotaCargoDetalleAgregar.push({
                            CHARGE_NOTE_DETAIL_ID: null,
                            CHARGE_NOTE_ID: null,
                            ITEM_SAT_ID: element.ITEM_SAT_ID,
                            ITEM_ID: element.ITEM_ID,
                            UNIT_MEASURE_ID: element.element.BILL_UNIT_MEASURE_ID,
                            AMOUNT: element.TOTAL , // Sin iba 16%
                            QUANTITY: element.QUANTITY,
                            DESCRIPTION: element.NAME,
                            IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                            IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                            isChecked: true,
                            checkedIva: true,
                            total: element.TOTAL,
                            totalFaltante: 0,
                            price:  (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                            index: id,
                            NAME: element.NAME, // Producto
                            NAME_SAT: element.NAME_SAT, // sat
                            unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                            AMOUNT_ORIGINAL: element.TOTAL
                        });
                        this.calcularValorUnitario(element.TOTAL, this.listaNotaCargoDetalle[this.listaNotaCargoDetalle.length - 1]);
                    }
                });

            } else { // No esta en modo edicion
                this.listaNotaCargoDetalle = [];
                this.listaNotaCargoDetalleAgregar = [];
                let index = 0;

                this.ventaDetalleListado.forEach((element) => {

                    const unidad = this.listaUnidad.find((p) => p.BILL_UNIT_MEASURE_ID === element.BILL_UNIT_MEASURE_ID);
                    index++;
                    this.listaNotaCargoDetalle.push({
                        CHARGE_NOTE_DETAIL_ID: null,
                        CHARGE_NOTE_ID: null,
                        ITEM_SAT_ID: element.ITEM_SAT_ID,
                        ITEM_ID: element.ITEM_ID,
                        UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                        AMOUNT: element.TOTAL, // Sin iba 16%
                        QUANTITY: element.QUANTITY,
                        DESCRIPTION: element.NAME,
                        IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                        IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                        isChecked: true,
                        checkedIva: true,
                        total: element.TOTAL,
                        totalFaltante: element.totalFaltante,
                        price: (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                        index,
                        NAME: element.NAME, // Producto
                        NAME_SAT: element.NAME_SAT, // sat
                        unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                        AMOUNT_ORIGINAL: element.TOTAL
                    });
                    this.listaNotaCargoDetalleAgregar.push({
                        CHARGE_NOTE_DETAIL_ID: null,
                        CHARGE_NOTE_ID: null,
                        ITEM_SAT_ID: element.ITEM_SAT_ID,
                        ITEM_ID: element.ITEM_ID,
                        UNIT_MEASURE_ID: element.BILL_UNIT_MEASURE_ID,
                        AMOUNT: element.TOTAL , // Sin iba 16%
                        QUANTITY: element.QUANTITY,
                        DESCRIPTION: element.NAME,
                        IVA_FACTOR: this.IVA_FIJO,  // IVA 16%
                        IVA_AMOUNT: (element.TOTAL * 16) / 116,  // 20 PESOS 16 %
                        isChecked: true,
                        checkedIva: true,
                        total: element.TOTAL,
                        totalFaltante: element.totalFaltante,
                        price:  (element.TOTAL - ((element.TOTAL * 16) / 116)) / element.QUANTITY,
                        index,
                        NAME: element.NAME, // Producto
                        NAME_SAT: element.NAME_SAT, // sat
                        unidad: (unidad !== null && unidad !== undefined) ? unidad.NAME : '',
                        AMOUNT_ORIGINAL: element.TOTAL
                    });
                    this.calcularValorUnitario(element.TOTAL, this.listaNotaCargoDetalle[this.listaNotaCargoDetalle.length - 1]);
                });
            }

            setTimeout( () => {
                this.dataSource.data = this.listaNotaCargoDetalle;
                this.calcularTotal();
            });
        },
        (error) => {
        console.log( error as any);
        }
    );
}

getNotaCargo(id: any) {
    this.notaCargo.BILL_CHARGE_NOTE_ID = this.dataService.id;
    this._generalService.metodoCallParams(this.notaCargo, `NotaCargo/consultBillCargoNote/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            //if (res.length > 0) {
                this.notaCargo = res.Table[0];
                this.notaCargo.NotaCargoDocumentos = res.Table1;
                this.notaCargo.NotaCargoIdDocumentos = new Array<number>();
                for(let i = 0; i < this.notaCargo.NotaCargoDocumentos.length; i++) {
                    this.notaCargo.NotaCargoIdDocumentos.push(this.notaCargo.NotaCargoDocumentos[i].BILL_ID);
                }
                this.notaCargoAgregar.controls['regimenFiscal'].setValue(this.notaCargo.TAX_REGIME_ID);
                this.notaCargoAgregar.controls['nombre'].setValue(this.notaCargo.CUSTOMER_NAME);
                this.notaCargoAgregar.controls['rfc'].setValue(this.notaCargo.CUSTOMER_RFC);
                this.notaCargoAgregar.controls['formaPago'].setValue(this.notaCargo.RECEIVER_PAYMENT_FORM_ID);
                this.notaCargoAgregar.controls['metodoPago'].setValue(this.notaCargo.RECEIVER_PAYMENT_METHOD_ID);
                this.notaCargoAgregar.controls['cfdi'].setValue(this.notaCargo.RECEIVER_CFDI_USE_ID);
                this.notaCargoAgregar.controls['tipoRelacion'].setValue(this.notaCargo.RELATION_TYPE_SAT_ID);
                this.notaCargoAgregar.controls['documentosRelacionados'].setValue(this.notaCargo.NotaCargoIdDocumentos);
                this.commentsControl.setValue(this.notaCargo.COMMENTS);
                if (this.notaCargo.BILL_STATUS_ID !== 1) {
                    this.displayedColumns = [
                        'producto',
                        'unidad',
                        'satID',
                        'descripcion',
                        'cantidad',
                        'valor',
                        'aplicaIVA',
                        'importeIVA',
                        'total'
                    ];
                } else {
                    this.displayedColumns = [
                        'acciones',
                        'producto',
                        'unidad',
                        'satID',
                        'descripcion',
                        'cantidad',
                        'valor',
                        'aplicaIVA',
                        'importeIVA',
                        'total'
                    ];
                }

            //}
        },
        (error) => {
        console.log( error as any);
        }
    );
}

getNotaCargoDetalle(id: any) {
    this.listaNotaCargoDetalle = [];
    this.listaNotaCargoDetalleAgregar = [];
    this.notaCargo.BILL_CHARGE_NOTE_ID = this.dataService.id;
    this._generalService.metodoCallParams(this.notaCargo, `NotaCargo/consultBillCargoNoteDetailt/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            console.log(res);
            this.listaNotaCargoDetalle = res;
            this.listaNotaCargoDetalleAgregar = [];
            for (let i = 0; i < this.listaNotaCargoDetalle.length; i++) {
                this.listaNotaCargoDetalle[i].index = i;
                this.listaNotaCargoDetalle[i].AMOUNT_ORIGINAL = this.listaNotaCargoDetalle[i].AMOUNT;
                this.listaNotaCargoDetalle[i].isChecked = true;
                this.listaNotaCargoDetalle[i].price = Math.round(((this.listaNotaCargoDetalle[i].AMOUNT / this.listaNotaCargoDetalle[i].QUANTITY) + Number.EPSILON) * 100) / 100;
                if (this.listaNotaCargoDetalle[i].IVA_FACTOR !== null && this.listaNotaCargoDetalle[i].IVA_FACTOR !== undefined) {
                    this.listaNotaCargoDetalle[i].checkedIva = true;
                } else {
                    this.listaNotaCargoDetalle[i].checkedIva = false;
                }
                this.listaNotaCargoDetalle[i].totalFaltante = undefined;
                this.listaNotaCargoDetalleAgregar.push(this.listaNotaCargoDetalle[i]);
            }
            if (this.dataService.factura.idDocuments !== null &&  this.dataService.factura.idDocuments !== undefined) {
                this.idDocuments = this.dataService.factura.idDocuments;
                this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
                if (this.facturaTipo === 1 && this.idDocuments !== null && this.idDocuments !== undefined) {
                    this.getVentasDetalle();
                } else {
                    setTimeout( () => {
                        this.dataSource.data = this.listaNotaCargoDetalle;
                        this.calcularTotal();
                      });
                }
            } else {
                setTimeout( () => {
                    this.dataSource.data = this.listaNotaCargoDetalle;
                    this.calcularTotal();
                  });
            }
        },
        (error) => {
        console.log( error as any);
        }
    );
}

buildForm() {
    this.notaCargoAgregar = this.formBuilder.group({
        regimenFiscal: this.formBuilder.control(null, [Validators.required] ),
        nombre: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
        rfc: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
        formaPago: this.formBuilder.control(null, [Validators.required] ),
        metodoPago: this.formBuilder.control(null, [Validators.required] ),
        cfdi: this.formBuilder.control(null, [Validators.required]),
        tipoRelacion: this.formBuilder.control(null, [Validators.required]),
        documentosRelacionados: this.formBuilder.control(null, [Validators.required])
    });
}

cerrarModal() {
    this.dataService.dialogRef.close();
}

timbrar() {
    const metodo = 'notaCargo/timbrar';
    this.notaCargo.BILL_CHARGE_NOTE_ID = this.dataService.id;
    this._generalService.metodoCallParams(this.notaCargo, metodo).subscribe(
            (result) => {
            this.dataService.guardado = true;
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
}

consultarCompania() {
    const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
    const idOrganizacion = usuarioSession.ORGANIZATION_ID;
    const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
    const params = {
        idCompania
    };
    this._generalService.metodoCallParams(params, `factura/consultEmisor/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                if (res[0].BILL_TAX_REGIME_ID !== null && res[0].BILL_TAX_REGIME_ID !== undefined && this.dataService.tipo !== 'editar') {
                    this.notaCargoAgregar.controls['regimenFiscal'].setValue(res[0].BILL_TAX_REGIME_ID);
                }
            }
        },
        (error) => {
            console.log( error as any);
        }
    );
}

consultarRegimenFiscales() {
    this._generalService.metodoCall(`factura/getRegimenFiscal/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaRegimenFiscal = res;
            } else {
                this.listaRegimenFiscal = [];
            }
        },
        (error) => {
            this.listaRegimenFiscal = [];
            console.log( error as any);
        }
    );
}

consultarFormaPago() {
    this._generalService.metodoCall(`factura/getFormaPago/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaFormaPago = res;
            } else {
                this.listaFormaPago = [];
            }
        },
        (error) => {
            this.listaFormaPago = [];
            console.log( error as any);
        }
    );
}

consultarMetodoPago() {
    this._generalService.metodoCall(`factura/getMetodoPago/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaMetodoPago = res;
            } else {
                this.listaMetodoPago = [];
            }
        },
        (error) => {
            this.listaMetodoPago = [];
            console.log( error as any);
        }
    );
}

consultarCFDI() {
    this._generalService.metodoCall(`factura/getCFDI/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaCFDI = res;
            } else {
                this.listaCFDI = [];
            }
        },
        (error) => {
            this.listaCFDI = [];
            console.log( error as any);
        }
    );
}

consultarSucursales() {
    this._generalService.metodoCall(`compania/consultarSucursales/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaSucursal = res;
            } else {
                this.listaSucursal = [];
            }
            const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
            const idOrganizacion = usuarioSession.ORGANIZATION_ID;
            const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
            // this.consultarCompania();
            this.consultarProducto(idCompania);
        },
        (error) => {
            this.listaSucursal = [];
            console.log( error as any);
        }
    );
}

consultarProducto(idCompania: number) {
    this._generalService.metodoCallParams(idCompania, `factura/consultProductos/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaProducto = res;
                this.viewDataProd = this.listaProducto.slice(0, this.itemsShowProd);
                this.viewDataProdEdit = this.viewDataProd;
                this.listaProductoEdit = JSON.parse(result);
            } else {
                this.listaProducto = [];
            }
        },
        (error) => {
            this.listaProducto = [];
            console.log( error as any);
        }
    );
}

consultSATcode() {
    this._generalService.metodoCall(`itemCodeSAT/consultItemSATcodes/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaSATCode = res;
                this.viewDataSat = this.listaSATCode.slice(0, this.itemsShowSat);
                this.viewDataSatEdit = this.viewDataSat;
                this.listaSATCodeEdit = JSON.parse(result);
            } else {
                this.listaSATCode = [];
            }
        },
        (error) => {
            this.listaSATCode = [];
            console.log( error as any);
        }
    );
}

consultarUnidades() {
    this._generalService.metodoCall(`factura/getUnidades/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaUnidad = res;
            } else {
                this.listaUnidad = [];
            }
        },
        (error) => {
            this.listaUnidad = [];
            console.log( error as any);
        }
    );
}

consultarTipoRelacion() {
  this._generalService.metodoCall(`notaCargo/consultarTipoRelacion/`).subscribe(
      (result) => {
          const res = JSON.parse(result);
          if (res !== null && res !== undefined && res.length > 0) {
              this.listaTipoRelacion = res;
          } else {
              this.listaTipoRelacion = [];
          }
      },
      (error) => {
          this.listaTipoRelacion = [];
      
      }
  );
}

consultarDocumentos() {
    this._generalService.metodoCall(`RecepcionPago/getDocumentos?CUSTOMER_ID=` + this.idCliente).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaDocumento = res;
            } else {
                this.listaDocumento = [];
            }
        },
        (error) => {
            this.listaDocumento = [];
            console.log( error as any);
        }
    );
}

regresar() {
    this.siguiente = false;
    this.establecerValoresPorDefecto();
}

onNext() {
    if (this.validarForm()) {
        this.notaCargo.TAX_REGIME_ID = this.notaCargoAgregar.controls['regimenFiscal'].value;
        this.notaCargo.CUSTOMER_NAME = this.notaCargoAgregar.controls['nombre'].value;
        this.notaCargo.CUSTOMER_RFC = this.notaCargoAgregar.controls['rfc'].value;
        this.notaCargo.RECEIVER_PAYMENT_FORM_ID = this.notaCargoAgregar.controls['formaPago'].value;
        this.notaCargo.RECEIVER_PAYMENT_METHOD_ID = this.notaCargoAgregar.controls['metodoPago'].value;
        this.notaCargo.RECEIVER_CFDI_USE_ID = this.notaCargoAgregar.controls['cfdi'].value;
        this.notaCargo.RELATION_TYPE_SAT_ID = this.notaCargoAgregar.controls['tipoRelacion'].value;
        this.notaCargo.NotaCargoIdDocumentos = this.notaCargoAgregar.controls['documentosRelacionados'].value;

        this.siguiente = true;
    }
}

guardarNotaCargoDetalleHeader() {
    this.validarFormulario();
    if (this.formularioValido) {
    this.mapearDatosFormControlEnModelo();
    this.agregarNotaCargoDetalle();
    }
}

guardarNotaCargoDetalleRow() {
    this.validarFormulario();
    if (this.formularioValido) {
        this.mapearDatosFormControlEnModelo();
        this.editarNotaCargoDetalle();
    }
}

agregarNotaCargoDetalle() {
    let index = 0;
    if (this.listaNotaCargoDetalle.length === 0) {
         index = 0;
    } else {
         index = this.listaNotaCargoDetalle.length;
    }
    this.notaCargoDetalle.index = index;
    this.listaNotaCargoDetalleAgregar[index] = this.notaCargoDetalle;
    this.listaNotaCargoDetalle.push(this.notaCargoDetalle);

    this.seEstaAgregando = false;
    this.seEstaEditando = false;
    setTimeout( () => {
      this.dataSource.data = this.listaNotaCargoDetalle;
      this.calcularTotal();
    });
  }

  editarNotaCargoDetalle() {
    const index1 = this.listaNotaCargoDetalle.findIndex((element) => element.index === this.notaCargoDetalle.index);
    this.listaNotaCargoDetalleAgregar[index1] = this.notaCargoDetalle;
    this.listaNotaCargoDetalle[index1] =  this.notaCargoDetalle;
    this.seEstaAgregando = false;
    this.seEstaEditando = false;
    setTimeout( () => {
      this.dataSource.data = this.listaNotaCargoDetalle;
      this.calcularTotal();
    });
  }

setAccionAgregar() {
    this.establecerValoresPorDefecto();
    this.seEstaEditando = false;
    this.seEstaAgregando = true;
    /***************************INFINITE SELECT**********************************/    
     setTimeout(() => 
                this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
            0);

     setTimeout(() => 
                this.selectElemSat.onOpen.subscribe(() => this.registerPanelScrollEventSat()),
            0);
    /***************************INFINITE SELECT**********************************/
}

cancelarAccion() {
this.establecerValoresPorDefecto();
}

validarFormulario() {
    this.formularioValido = false;
    const campoRequerido = 'Favor de llenar los campos requeridos';
    this.resaltarCamposConErrores();
    if (
        this.unidadControl.invalid ||
        this.productoControl.invalid ||
        this.productoSATControl.invalid ||
        this.descripcionControl.invalid ||
        this.cantidadControl.invalid ||
        this.valorControl.invalid ||
        this.importeIVAControl.invalid ||
        this.totalControl.invalid ||
        this.aplicaIVAControl.invalid
    ) {
        this._generalService.toastCall(campoRequerido);
        return;
    }

    if (this.notaCargoDetalle.totalFaltante !== null && (this.cantidadControl.value > this.notaCargoDetalle.totalFaltante)) {
        this._generalService.toastCall('La cantidad sobrepaso al limite de la venta (Maximo ' + (this.notaCargoDetalle.totalFaltante) + ')');
        return;
    } 

    this.formularioValido = true;
}

resaltarCamposConErrores() {
    this.unidadControl.markAsTouched();
    this.productoControl.markAsTouched();
    this.productoSATControl.markAsTouched();
    this.descripcionControl.markAsTouched();
    this.cantidadControl.markAsTouched();
    this.valorControl.markAsTouched();
    this.importeIVAControl.markAsTouched();
    this.totalControl.markAsTouched();
    this.aplicaIVAControl.markAsTouched();
}

mapearDatosFormControlEnModelo() {

    this.notaCargoDetalle.UNIT_MEASURE_ID = this.unidadControl.value;
    this.notaCargoDetalle.ITEM_ID = this.productoControl.value;
    const producto = this.listaProducto.find((p) => p.ITEM_ID === this.notaCargoDetalle.ITEM_ID);
    if (producto !== null && producto !== undefined) {
        this.notaCargoDetalle.ITEM_SAT_ID = producto.ITEM_SAT_ID;
        this.notaCargoDetalle.NAME_SAT = producto.NAME_SAT;
        this.notaCargoDetalle.NAME = producto.NAME;
    }
    this.notaCargoDetalle.ITEM_SAT_ID = this.productoSATControl.value;
    const productoSAT =  this.listaSATCode.find((p) => p.itemSATcodeId === this.productoSATControl.value);
    if (productoSAT !== null && productoSAT !== undefined) {
        this.notaCargoDetalle.NAME_SAT = productoSAT.SATcode  + ' - ' + productoSAT.DESCRIPTION;
    }
    this.notaCargoDetalle.DESCRIPTION = this.descripcionControl.value;
    this.notaCargoDetalle.QUANTITY = +this.cantidadControl.value;
    this.notaCargoDetalle.price = +this.valorControl.value;
    if (this.aplicaIVAControl.value !== false && this.aplicaIVAControl.value !== undefined) {
        this.notaCargoDetalle.IVA_FACTOR = this.IVA_FIJO;
        this.notaCargoDetalle.IVA_AMOUNT =  +this.importeIVAControl.value;
        this.notaCargoDetalle.checkedIva = true;
        this.notaCargoDetalle.AMOUNT = +this.totalControl.value - +this.importeIVAControl.value;
        this.notaCargoDetalle.AMOUNT = +this.notaCargoDetalle.AMOUNT.toFixed(2);
    } else {
        this.notaCargoDetalle.IVA_FACTOR = null;
        this.notaCargoDetalle.checkedIva = false;
        this.notaCargoDetalle.IVA_AMOUNT = 0.000;
        this.notaCargoDetalle.AMOUNT = +this.totalControl.value;
        this.notaCargoDetalle.AMOUNT = +this.notaCargoDetalle.AMOUNT.toFixed(2);
    }
    this.notaCargoDetalle.isChecked = true;
    const unidad = this.listaUnidad.find((p) => p.BILL_UNIT_MEASURE_ID === this.notaCargoDetalle.UNIT_MEASURE_ID);
    this.notaCargoDetalle.unidad = unidad.NAME;
    this.notaCargoDetalle.total = +this.totalControl.value;
}

establecerValoresPorDefecto() {
    this.seEstaAgregando = false;
    this.seEstaEditando = false;
    this.notaCargoDetalle = new NotaCargoDetail();

    this.unidadControl.reset();
    this.productoControl.reset();
    this.productoSATControl.reset();
    this.descripcionControl.reset();
    this.cantidadControl.reset();
    this.valorControl.reset();
    this.importeIVAControl.reset();
    this.totalControl.reset(0);
    this.aplicaIVAControl.reset(true);

    this.itemsShowProd = 10;
    this.itemsShowSat = 10;
}

establecerDetalle(notaCargoDetail: NotaCargoDetail) {

    this.seEstaAgregando = false;
    this.seEstaEditando = true;

    /***************************INFINITE SELECT**********************************/    
     setTimeout(() => 
                this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
            0);

     setTimeout(() => 
                this.selectElemSat.onOpen.subscribe(() => this.registerPanelScrollEventSat()),
            0);
    /***************************INFINITE SELECT**********************************/

    this.notaCargoDetalle = notaCargoDetail;
    this.notaCargoDetalle.CHARGE_NOTE_DETAIL_ID = notaCargoDetail.CHARGE_NOTE_DETAIL_ID;
    this.transaccionEnCurso = true;
    this.unidadControl.setValue(notaCargoDetail.UNIT_MEASURE_ID);
    this.productoControl.setValue(notaCargoDetail.ITEM_ID);
    const producto = this.listaProducto.find((p) => p.ITEM_ID === this.notaCargoDetalle.ITEM_ID);

    this.moverSeleccion();
    this.moverSeleccionSat();

    this.productoSATControl.setValue(this.notaCargoDetalle.ITEM_SAT_ID);
    const productoSAT = this.listaSATCode.find((p) => p.itemSATcodeId === this.productoSATControl.value);
    if (productoSAT !== null && productoSAT !== undefined) {
        this.notaCargoDetalle.NAME_SAT = productoSAT.SATcode  + ' - ' + productoSAT.DESCRIPTION;
    }
    this.descripcionControl.setValue(notaCargoDetail.DESCRIPTION);
    this.cantidadControl.setValue(notaCargoDetail.QUANTITY);
    this.valorControl.setValue(notaCargoDetail.price);
    this.importeIVAControl.setValue(notaCargoDetail.IVA_AMOUNT);
    this.totalControl.setValue(notaCargoDetail.total);
    if (notaCargoDetail.IVA_AMOUNT !== null && notaCargoDetail.IVA_AMOUNT !== undefined && notaCargoDetail.IVA_AMOUNT > 0) {
        this.aplicaIVAControl.setValue(true);
    } else {
        this.aplicaIVAControl.setValue(false);
    }

    this.transaccionEnCurso = false;
}

moverSeleccion() {
    /***************************INFINITE SELECT**********************************/
    const index = this.listaProductoEdit.findIndex(x => x.ITEM_ID == this.notaCargoDetalle.ITEM_ID);
    var a = this.listaProductoEdit.splice(index,1);
    this.listaProductoEdit.unshift(a[0]);
    this.itemsShowProd = 10;
    this.viewDataProdEdit = this.listaProductoEdit.slice(0, 10);
    /***************************INFINITE SELECT**********************************/
}

moverSeleccionSat() {
    /***************************INFINITE SELECT**********************************/
    const index = this.listaSATCodeEdit.findIndex(x => x.itemSATcodeId == this.notaCargoDetalle.ITEM_SAT_ID);
    var a = this.listaSATCodeEdit.splice(index,1);
    this.listaSATCodeEdit.unshift(a[0]);
    this.itemsShowSat = 10;
    this.viewDataSatEdit = this.listaSATCodeEdit.slice(0, 10);
    /***************************INFINITE SELECT**********************************/
}

eliminarNotaCargoDetalle(notaCargoDetail: NotaCargoDetail) {

    const metodo = 'NotaCargo/deleteNotaCargoDetalle';
    this._generalService.metodoCallParams(notaCargoDetail, metodo).subscribe(
        (result) => {
            this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');
            this.getNotaCargoDetalle(this.dataService.id);
        },
        (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
        }
    );

}

eliminar(id) {
    const index1 = this.listaNotaCargoDetalle.findIndex((element) => element.index === id);
    this.listaNotaCargoDetalle.splice(index1, 1);
    this.listaNotaCargoDetalleAgregar.splice(index1, 1);
    setTimeout( () => {
        this.dataSource.data = this.listaNotaCargoDetalle;
        this.calcularTotal();
    });
}

guardarNotaCargo() {
    if (this.validarGuardar()) {
        let metodo = 'NotaCargo/addNotaCargo';
        this.notaCargo.BILL_CHARGE_NOTE_ID = null;
        if (this.dataService.tipo === 'editar') {
            metodo = 'NotaCargo/updateNotaCargo';
            this.notaCargo.BILL_CHARGE_NOTE_ID = this.dataService.id;
        } else {
            this.notaCargo.NotaCargoDocumentos = new Array<NotaCargoDocumento>();
            for (let i = 0; i < this.notaCargo.NotaCargoIdDocumentos.length; i++) {
                const strUUID =  this.listaDocumento.find((p) => p.BILL_ID === this.notaCargo.NotaCargoIdDocumentos[i]);
                this.notaCargo.NotaCargoDocumentos.push({BILL_ID: this.notaCargo.NotaCargoIdDocumentos[i], UUID: strUUID.UUID});
            }
        }
        this.notaCargo.CUSTOMER_ID = this.idCliente;
        this.notaCargo.COMMENTS = this.commentsControl.value;
        this.notaCargo.BILL_STATUS_ID = 1;
        const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
        const idOrganizacion = usuarioSession.ORGANIZATION_ID;
        this.notaCargo.ORGANIZATION_ID = idOrganizacion;            
        if (this.impuestos > 0) {
            this.notaCargo.IVA_FACTOR = this.IVA_FIJO;
        }
        this.notaCargo.SUBTOTAL_BEFORE_TAX = this.subtotal;
        this.notaCargo.TOTAL_IVA = this.impuestos;
        this.notaCargo.TOTAL_TAX = 0;
        this.notaCargo.loacs = sessionStorage.getItem('acslo');

        //aqui se agrega el detalle a this.notaCargo
        this.notaCargo.NotaCargoDetalle = this.listaNotaCargoDetalleAgregar;

        this._generalService.metodoCallParams(this.notaCargo, metodo).subscribe(
            (result) => {
            this.dataService.guardado = true;
            // this.cerrarModal();
            
            if(this.dataService.tipo === 'editar'){
                this._generalService.toastCall('El registro se modificó exitosamente!');
            } else {
                this.dataService.tipo = 'editar';
                this.dataService.id = +result.data;
                this.id = this.dataService.id;
                this._generalService.toastCall('El registro se agregó exitosamente!');
                this.getNotaCargo(this.dataService.id);
                this.getNotaCargoDetalle(this.dataService.id);
            }
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }
}

validarGuardar() {
    if (!this.notaCargoAgregar.controls['regimenFiscal'].valid) {
        this._generalService.toastCall('El Regimen Fiscal es requerido');
        this.notaCargoAgregar.controls['regimenFiscal'].markAsTouched();
        return false;
    }
    if (!this.notaCargoAgregar.controls['nombre'].valid) {
        this._generalService.toastCall('El Nombre es requerido');
        this.notaCargoAgregar.controls['nombre'].markAsTouched();
        return false;
    }
    if (!this.notaCargoAgregar.controls['rfc'].valid) {
        this._generalService.toastCall('El RFC es requerido');
        this.notaCargoAgregar.controls['rfc'].markAsTouched();
        return false;
    }
    if (!this.notaCargoAgregar.controls['formaPago'].valid) {
        this._generalService.toastCall('La Forma de Pago es requerida');
        this.notaCargoAgregar.controls['formaPago'].markAsTouched();
        return false;
    }
    if (!this.notaCargoAgregar.controls['metodoPago'].valid) {
        this._generalService.toastCall('El Metodo de Pago es requerido');
        this.notaCargoAgregar.controls['metodoPago'].markAsTouched();
        return false;
    }
    if (!this.notaCargoAgregar.controls['cfdi'].valid) {
        this._generalService.toastCall('El Uso CFDI es requerido');
        this.notaCargoAgregar.controls['cfdi'].markAsTouched();
        return false;
    }
    if (!this.notaCargoAgregar.controls['tipoRelacion'].valid) {
        this._generalService.toastCall('El Tipo de Relación es requerido');
        this.notaCargoAgregar.controls['tipoRelacion'].markAsTouched();
        return false;
    }
    if (!this.notaCargoAgregar.controls['documentosRelacionados'].valid) {
        this._generalService.toastCall('Los Documentos Relacionados son requeridos');
        this.notaCargoAgregar.controls['documentosRelacionados'].markAsTouched();
        return false;
    }


    let cantidadAguardar = 0;
    let index = 0;
    let falloGrid = false;
    let stringError = '';
    this.listaNotaCargoDetalleAgregar.forEach((element) => {
        index++;
        //if (element.isChecked) {
            if (element.UNIT_MEASURE_ID === null || element.UNIT_MEASURE_ID === undefined ) {
                stringError += 'Error Renglón ' + index + ' La Unidad es requerida, ';
                falloGrid = true;
            }
            if (element.ITEM_SAT_ID === null || element.ITEM_SAT_ID === undefined ) {
                 stringError += 'Error Renglón ' + index + ' La Cve. Prod. o Servicio es requerida, ';
                 falloGrid = true;
             }
            if (element.totalFaltante !== null && (element.QUANTITY > element.totalFaltante)) {
                stringError +=  'Error Renglón ' + index +  ' La cantidad sobrepaso al limite de la venta (Maximo ' + (element.totalFaltante) + '), ';
                falloGrid = true;
            } 
            cantidadAguardar++;
        //}
    });

    if (falloGrid) {
        this._generalService.toastCall(stringError);
        return false;
    }
    if (cantidadAguardar > 0) {
        if(!falloGrid){
            return true;
        } 
    } else {
        this._generalService.toastCall('Debe de activar por lo menos un renglón.');
        return false;
    }

}

validarForm() {
     if (!this.notaCargoAgregar.controls['regimenFiscal'].valid) {
         this._generalService.toastCall('El Regimen Fiscal es requerido');
         this.notaCargoAgregar.controls['regimenFiscal'].markAsTouched();
         return false;
     }
     if (!this.notaCargoAgregar.controls['nombre'].valid) {
         this._generalService.toastCall('El Nombre es requerido');
         this.notaCargoAgregar.controls['nombre'].markAsTouched();
         return false;
     }
     if (!this.notaCargoAgregar.controls['rfc'].valid) {
         this._generalService.toastCall('El RFC es requerido');
         this.notaCargoAgregar.controls['rfc'].markAsTouched();
         return false;
     }
     if (!this.notaCargoAgregar.controls['formaPago'].valid) {
         this._generalService.toastCall('La Forma de Pago es requerida');
         this.notaCargoAgregar.controls['formaPago'].markAsTouched();
         return false;
     }
     if (!this.notaCargoAgregar.controls['metodoPago'].valid) {
         this._generalService.toastCall('El Metodo de Pago es requerido');
         this.notaCargoAgregar.controls['metodoPago'].markAsTouched();
         return false;
     }
     if (!this.notaCargoAgregar.controls['cfdi'].valid) {
         this._generalService.toastCall('El Uso CFDI es requerido');
         this.notaCargoAgregar.controls['cfdi'].markAsTouched();
         return false;
     }
     if (!this.notaCargoAgregar.controls['tipoRelacion'].valid) {
        this._generalService.toastCall('El Tipo de Relación es requerido');
        this.notaCargoAgregar.controls['tipoRelacion'].markAsTouched();
        return false;
     }
     if (!this.notaCargoAgregar.controls['documentosRelacionados'].valid) {
        this._generalService.toastCall('Los Documentos Relacionados son requeridos');
        this.notaCargoAgregar.controls['documentosRelacionados'].markAsTouched();
        return false;
     }

     return true;

 }


setearSAT(event: any, index: number) {
    if (event !== undefined && event !== null) {
        
            const producto = this.listaProducto.find((element) => element.ITEM_ID === event.value);
            const ivaValor = (producto.BASE_SALE_PRICE * 16) / 116;
            const valor = producto.BASE_SALE_PRICE - (ivaValor);
            this.valorControl.setValue(valor.toFixed(2));
            // Setear si existe ID SAT
            if (producto.ITEM_SAT_ID !== null) {
                this.productoSATControl.setValue(producto.ITEM_SAT_ID);
            } else {
                this.productoSATControl.reset();
            }
            if (producto.BILL_UNIT_MEASURE_ID !== null) {
                this.unidadControl.setValue(producto.BILL_UNIT_MEASURE_ID);
            } else {
                this.unidadControl.reset();
            }
            this.descripcionControl.setValue(producto.NAME);
            this.cantidadControl.setValue(1);
            this.totalControl.setValue(producto.BASE_SALE_PRICE);
            this.aplicaIVAControl.setValue(true);
          
            this.importeIVAControl.setValue(ivaValor.toFixed(2));

    } else {
        this.productoSATControl.reset();
        this.unidadControl.reset();
        this.valorControl.reset();
        this.cantidadControl.reset();
        this.descripcionControl.reset();
        this.aplicaIVAControl.reset(true);
        this.importeIVAControl.reset();
        this.totalControl.reset();
    }
}

setearIVA(event: any) {
    if (event.checked) {
        this.importeIVAControl.setValue((this.totalControl.value * 16) / 116);
        this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(2)));
        const valorUnitario = ((this.totalControl.value - this.importeIVAControl.value) / this.cantidadControl.value);
        this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2))); 

    } else {
        const valorUnitario = ((this.totalControl.value) / this.cantidadControl.value);
        this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2))); 
        this.importeIVAControl.reset();
        this.importeIVAControl.disable();
    }
}

calcularValorUnitario2(cantidad: any, notaCargoDetail: NotaCargoDetail) {
    if (cantidad !== null && cantidad !== undefined) {

        if ((this.productoControl.value === null || this.productoControl.value === undefined)
            && this.totalControl.value !== null && this.totalControl.value !== undefined) {
            this.importeIVAControl.setValue((this.totalControl.value * 16) / 116);
            this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(2)));
        }
        if (this.totalControl.value !== null && this.totalControl.value !== undefined) {
            if (this.aplicaIVAControl.value) {
                const valorUnitario = ((this.totalControl.value  - this.importeIVAControl.value) / this.cantidadControl.value);
                this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2)));
            } else {
                const valorUnitario = this.totalControl.value / this.cantidadControl.value;
                this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2)));
            }
        }

    } else {
        if (this.aplicaIVAControl.value) {
            this.importeIVAControl.reset();
        }
        this.valorControl.reset();
    }
}


calcularValorUnitario(importe: any, notaCargoDetail: NotaCargoDetail) {
    if (importe !== null && importe !== undefined) {
        
        if (this.aplicaIVAControl.value) {
           
            const valorUnitario = ((this.totalControl.value / 1.16) / this.cantidadControl.value);
            this.importeIVAControl.setValue((valorUnitario * this.cantidadControl.value) * this.IVA_FIJO);
            this.importeIVAControl.setValue(parseFloat(this.importeIVAControl.value.toFixed(2)));
            this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2)));
        } else {
            const valorUnitario = this.totalControl.value / this.cantidadControl.value;
            this.valorControl.setValue(parseFloat(valorUnitario.toFixed(2)));
        }

    } else {
        if (this.aplicaIVAControl.value) {
            this.importeIVAControl.reset();
        }
        this.valorControl.reset();
    }
}

calcularTotal() {
    // SubTotal Impuestos Total
    let sumaSubtotal = 0;
    let sumaImpuestos = 0;
    let sumaTotal = 0;
    for (let i = 0; i < this.listaNotaCargoDetalle.length; i++) {
        //if (this.listaNotaCargoDetalle[i].isChecked) {
            sumaSubtotal += +this.listaNotaCargoDetalle[i].AMOUNT;
            sumaImpuestos += (this.listaNotaCargoDetalle[i].IVA_AMOUNT !== null && this.listaNotaCargoDetalle[i].IVA_AMOUNT !== undefined) ? +this.listaNotaCargoDetalle[i].IVA_AMOUNT : 0.00;
            sumaTotal += +this.listaNotaCargoDetalle[i].total;
        //}
    }
    this.subtotal = +sumaSubtotal.toFixed(2);
    this.impuestos = +sumaImpuestos.toFixed(2);
    this.total = +sumaTotal.toFixed(2);
}

activarRow(element, event) {
    const index = this.listaNotaCargoDetalle.findIndex((obj) => obj.index === element.index);
    if (event.checked) {
        this.listaNotaCargoDetalleAgregar[index].isChecked = true;

    } else {
        this.listaNotaCargoDetalleAgregar[index].isChecked = false;
    }
    this.calcularTotal();
}

eliminarRow(element) {
    const index = this.listaNotaCargoDetalle.findIndex((obj) => obj.index === element.index);
    if (element.CHARGE_NOTE_DETAIL_ID !== null && element.CHARGE_NOTE_DETAIL_ID !== undefined) {
        this.eliminarNotaCargoDetalle(this.listaNotaCargoDetalle[index]);
    } else {
        this.eliminar(element.index);
    }

}

onKeyUpProd(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredProd = this.listaProducto.filter((obj) => {
        return obj.NAME.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })

      arr = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
      this.isFilteredProd = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredProd = false;
      this.filteredItemsShowProd = 10;
      this.arrayFilteredProd = undefined;
      arr = this.listaProducto.slice(0, this.itemsShowProd);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    if(this.seEstaEditando) {
        this.viewDataProdEdit = arr;
    } else {
        this.viewDataProd = arr;
    }
    /***************************INFINITE SELECT**********************************/
}

onKeyUpSat(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredSat = this.listaSATCode.filter((obj) => {
        return obj.SATcode.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1 || 
        obj.DESCRIPTION.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })

      arr = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
      this.isFilteredSat = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredSat = false;
      this.filteredItemsShowSat = 10;
      this.arrayFilteredSat = undefined;
      arr = this.listaSATCode.slice(0, this.itemsShowSat);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    if(this.seEstaEditando) {
        this.viewDataSatEdit = arr;
    } else {
        this.viewDataSat = arr;
    }
    /***************************INFINITE SELECT**********************************/
}

/***************************INFINITE SELECT**********************************/
registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
}

loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredProd) {
        if(this.filteredItemsShowProd < this.arrayFilteredProd.length) {
            this.filteredItemsShowProd += 10;
            if(this.seEstaEditando) {
                this.viewDataProdEdit = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
            } else {
                this.viewDataProd = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
            }
        }
      } else {
        if(this.seEstaEditando) {
            if(this.itemsShowProd < this.listaProductoEdit.length) {
                this.itemsShowProd += 10;
                this.viewDataProdEdit = this.listaProductoEdit.slice(0, this.itemsShowProd);
            }
        } else {
            if(this.itemsShowProd < this.listaProducto.length) {
                this.itemsShowProd += 10;
                this.viewDataProd = this.listaProducto.slice(0, this.itemsShowProd);
            }
        }            
      }
    }
}

registerPanelScrollEventSat() {
    const panelsat = this.selectElemSat.panel.nativeElement;
    panelsat.addEventListener('scroll', event => this.loadAllOnScrollSat(event));
}

loadAllOnScrollSat(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredSat) {
        if(this.filteredItemsShowSat < this.arrayFilteredSat.length) {
            this.filteredItemsShowSat += 10;
            if(this.seEstaEditando) {
                this.viewDataSatEdit = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
            } else {
                this.viewDataSat = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
            }
        }
      } else {
        if(this.seEstaEditando) {
            if(this.itemsShowSat < this.listaSATCodeEdit.length) {
                this.itemsShowSat += 10;
                this.viewDataSatEdit = this.listaSATCodeEdit.slice(0, this.itemsShowSat);
            }
        } else {
            if(this.itemsShowSat < this.listaSATCode.length) {
                this.itemsShowSat += 10;
                this.viewDataSat = this.listaSATCode.slice(0, this.itemsShowSat);
            }
        }            
      }
    }
}
/***************************INFINITE SELECT**********************************/

}



// WEBPACK FOOTER //
// ./src/app/nota-cargo/agregar-editar/nota-cargo-detalle.component.ts